import { HistoryOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { ItemType, SubMenuType } from 'antd/es/menu/interface';

import styles from './DocumentationScreen.module.css';

import { DOCUMENTATION_KEY, DOCUMENTATION_KEY_PREFIX } from '../../../side-nav/sidenav-constants';
import { DocumentationModel } from '../models/documentation-list';

function getDocumentationNavItems(model: DocumentationModel): ItemType[] {
  return model.documentation.length > 0
    ? model.documentation.map((document) => ({
        label: <span title={document.label}>{document.label}</span>,
        className: model.isMobile ? styles.menuItemMobile : styles.menuItemDesktop,
        icon: document.id === 'release-history' ? <HistoryOutlined /> : <QuestionCircleOutlined />,
        key: `${DOCUMENTATION_KEY_PREFIX}${document.id}`,
      }))
    : [
        {
          label: model.loading ? 'Loading…' : 'No available documentation',
          key: `${DOCUMENTATION_KEY_PREFIX}empty`,
          disabled: true,
        },
      ];
}

export function getDocumentationNav({ model }: { model: DocumentationModel }): SubMenuType {
  return {
    label: 'Documentation',
    key: DOCUMENTATION_KEY,
    icon: <QuestionCircleOutlined />,
    children: getDocumentationNavItems(model),
  };
}
